import React from "react";

export default function ListItem({ item, index }) {
  return (
    <div className="list--config">
      <ul className="attendance-table build-table build-table--bold build-table--light build-table__item">
        <li className="build-table__item">{index + 1}</li>
        <li className="build-table__item">{item.student}</li>
        <li className="build-table__item">{item.student_id}</li>
        <li className="build-table__item">{item.group}</li>
        <li className="build-table__item">{item.subject}</li>
        <li className="build-table__item">{item.teachers}</li>
        <li className="build-table__item" style={{ color: "orange" }}>
          {item.passing_score} {"ball"}
        </li>
        <li className="build-table__item" style={{ color: "red" }}>
          {item.total_score} {"ball"}
        </li>
        <li className="build-table__item">{item.date}</li>
      </ul>
    </div>
  );
}
